import { Form } from '@/helpers/Form';
import Pager from '@/helpers/Pager';
import { FilterModel } from '../services/PropertiesService';

export default {
    namespaced: true,
    state: {
        filter: Form.createPersistedState<FilterModel>({
            search: '',
            activeStatus: "Active",
            prestigeStatus: "All",
            citiesIds: [],
            districtsIds: [],
            ownerName: '',
            guestyId: null,
            hasNoDistrict: false
        }, undefined, 'renterPropertiesFilter'),
        pager: new Pager(1, undefined, 'PropertyName', 'ASC'),
        activityPager: new Pager(1, undefined, 'DueDate', 'DESC'),
        notesPager: new Pager(1, undefined, 'Content', 'ASC'),
        stocktakesPager: new Pager(1, undefined, 'dateCreatedUtc', 'ASC'),
        savedScrollPosition: 0
    }
};
